<div hidden>
    <ng-template #dialogOverlay>
        <div style="
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1001;
                background-color: #000;
                opacity: 0.3;
                width: 100vw;
                height: 100vh;
            "></div>
    </ng-template>
    <ng-template #loadingSpinner>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>
</div>

<div class="card scroll-container" fullscreen>
    <div hidden class="page-overlay">
        <div class="page-overlay-content">
            <div *ngIf="loading; then loadingSpinner"></div>
        </div>
    </div>
    <div *ngIf="false">
        <form [formGroup]="passwordForm" class="flex align-items-center gap-2">
            <div class="field">
                <label for="password">Change Password:</label>
                <input id="password" type="password" formControlName="password" class="p-inputtext" #password />
                <div class="spacer">&nbsp;</div>
                <input type="submit" value="Save" class="p-button p-button-success" [disabled]="!password.value" />
            </div>
        </form>
    </div>

    <form [formGroup]="userSettingsForm" #userSettings="ngForm" id="userSettings">
        <div class="sticky-table-container">
            <p-table stripedRows *ngIf="rowGroupMetadata; else loadingSpinner" [value]="settings" dataKey="EmployeeListID"
                tableStyleClass="table p-datatable-full tabulator" [globalFilterFields]="['EmpSettingTypeLabel']"
                (onEditInit)="onEditInit($event)" (onEditComplete)="onEditComplete($event)"
                (onFilter)="onFilter($event)" (onSort)="onSort($event)" (sortFunction)="customSort($event)"
                [customSort]="true" [rowHover]="true" #dtSettings>
                <ng-template #header let-item>
                    <tr>
                        <th class="status-cell">
                            <i class="pi pi-exclamation-circle" title="Status"></i>
                        </th>
                        <th>
                            Category
                            <p-columnFilter field="CatID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect [virtualScroll]="true" itemSize="32" defaultLabel="Category" maxSelectedLabels="1" appendTo="body"
                                        [options]="categoryItems" [filter]="true" (onChange)="filter($event.value)">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>

                                      <!-- <p-sortIcon
                                pSortableColumn="CatDescription"
                                field="CatDescription"
                                ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"
                            ></p-sortIcon> -->
                        </th>
                        <th>
                            Setting
                            <p-columnFilter type="text" matchMode="contains" field="EmpSettingID" display="menu" class="ml-auto" />
                        </th>
                        <th>
                            Value
                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-item let-editing="editing" let-ri="rowIndex">
                    <tr>
                        <td class="status-cell disabled">
                            <div>
                                <ef-status-icon [status]="item?.Status?.StatusCode"
                                    [message]="item?.Status?.Message"></ef-status-icon>
                            </div>
                        </td>
                        <td *ngIf="rowGroupMetadata[item.CatID].index === ri"
                            [attr.rowspan]="rowGroupMetadata[item.CatID].size" class="disabled">
                            <strong>{{ item?.CatDescription }}</strong>
                        </td>
                        <td class="disabled">
                            {{ item?.EmpSettingTypeLabel }}
                        </td>
                        <td #settingValue [pEditableColumn]="item"
                            [pEditableColumnField]="'EmpSettingValue'">
                            <div *ngIf="item.CtrlType == 'checkbox'">
                                <div *ngIf="item.Status.StatusCode != 99" style="padding-left: 0.31rem">
                                    <p-checkbox [disabled]="item.IsReadOnly" binary="true" type="checkbox"
                                        [(ngModel)]="item.EmpSettingValue" [name]="item.EmpSettingType"
                                        [formControlName]="
                                        item.EmpSettingType
                                    " (onChange)="
                                        checkboxChanged($event, item)
                                    "></p-checkbox>
                                </div>
                                <div *ngIf="item.Status.StatusCode == 99">
                                    <div style="padding: 0.4rem 0 0 0.4rem">
                                        <div>
                                            <ef-status-icon [status]="
                                                item?.Status?.StatusCode
                                            " [message]="
                                                item?.Status?.Message
                                            "></ef-status-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="item.CtrlType == 'combobox'">
                                <div *ngIf="!item.IsReadOnly">
                                    <p-select
                                        [style]="{ width: '100%' }"
                                        appendTo="body"
                                        [filter]="true"
                                        [options]="
                                            getValuesForDropdown(
                                                item.EmpSettingType
                                            )
                                        "
                                        [(ngModel)]="item.EmpSettingValue"
                                        (onChange)="
                                            dropdownChanged($event, item)
                                        "
                                        [formControlName]="
                                            item.EmpSettingType
                                        "
                                        [name]="item.EmpSettingType"
                                    ></p-select>
                                </div>
                                <div *ngIf="item.IsReadOnly">
                                    {{
                                        getDescriptionForDropdown(
                                            item?.EmpSettingType,
                                            item?.EmpSettingValue
                                        )
                                    }}
                                </div>
                            </div>
                            <div *ngIf="item.CtrlType == 'password'">
                                <div *ngIf="!item.IsReadOnly">
                                    <input
                                        autocomplete="new-password"
                                        placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
                                        type="password"
                                        pPassword
                                        [(ngModel)]="item.EmpSettingValue"
                                        (input)="
                                            textboxChanged(
                                                item.EmpSettingValue,
                                                item
                                            )
                                        "
                                        (blur)="
                                            textboxBlur(
                                                item.EmpSettingValue,
                                                item
                                            )
                                        "
                                        [formControlName]="
                                            item.EmpSettingType
                                        "
                                        [name]="item.EmpSettingType"
                                    />
                                </div>
                                <div *ngIf="item.IsReadOnly">
                                    &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                </div>
                            </div>
                            <!-- <p-cellEditor [ngSwitch]="item.CtrlType">
                                <ng-template
                                    *ngSwitchCase="'Checkbox'"
                                    pTemplate="input"
                                >
                                    <div
                                        *ngIf="item.Status.StatusCode != 99"
                                        style="padding-left: 0.31rem"
                                    >
                                        <p-checkbox
                                            [disabled]="item.IsReadOnly"
                                            binary="true"
                                            type="checkbox"
                                            [(ngModel)]="item.EmpSettingValue"
                                            [name]="item.EmpSettingType"
                                            [formControlName]="
                                                item.EmpSettingType
                                            "
                                            (onChange)="
                                                checkboxChanged($event, item)
                                            "
                                        ></p-checkbox>
                                    </div>
                                    <div *ngIf="item.Status.StatusCode == 99">
                                        <div style="padding: 0.4rem 0 0 0.4rem">
                                            <div>
                                                <ef-status-icon
                                                    [status]="
                                                        item?.Status?.StatusCode
                                                    "
                                                    [message]="
                                                        item?.Status?.Message
                                                    "
                                                ></ef-status-icon>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template
                                    *ngSwitchCase="'checkbox'"
                                    pTemplate="output"
                                    ><div>
                                        <p-checkbox
                                            [disabled]="item.IsReadOnly"
                                            binary="true"
                                            type="checkbox"
                                            [(ngModel)]="item.EmpSettingValue"
                                            [name]="item.EmpSettingType"
                                            [formControlName]="
                                                item.EmpSettingType
                                            "
                                            (onChange)="
                                                checkboxChanged($event, item)
                                            "
                                        ></p-checkbox>
                                    </div>
                                </ng-template>
                                <ng-template
                                    *ngSwitchCase="'combobox'"
                                    pTemplate="input"
                                >
                                    <div *ngIf="!item.IsReadOnly">
                                        <p-dropdown
                                            appendTo="body"
                                            [filter]="true"
                                            [options]="
                                                getValuesForDropdown(
                                                    item.EmpSettingType
                                                )
                                            "
                                            [(ngModel)]="item.EmpSettingValue"
                                            (onChange)="
                                                dropdownChanged($event, item)
                                            "
                                            [formControlName]="
                                                item.EmpSettingType
                                            "
                                            [name]="item.EmpSettingType"
                                        ></p-dropdown>
                                    </div>
                                    <div *ngIf="item.IsReadOnly">
                                        {{
                                            getDescriptionForDropdown(
                                                item?.EmpSettingType,
                                                item?.EmpSettingValue
                                            )
                                        }}
                                    </div>
                                </ng-template>
                                <ng-template
                                    *ngSwitchCase="'combobox'"
                                    pTemplate="output"
                                >
                                    {{
                                        getDescriptionForDropdown(
                                            item?.EmpSettingType,
                                            item?.EmpSettingValue
                                        )
                                    }}
                                </ng-template>
                                <ng-template
                                    *ngSwitchCase="'password'"
                                    pTemplate="input"
                                >
                                    <div *ngIf="!item.IsReadOnly">
                                        <input
                                            autocomplete="new-password"
                                            type="password"
                                            pPassword
                                            [(ngModel)]="item.EmpSettingValue"
                                            (input)="
                                                textboxChanged(
                                                    item.EmpSettingValue,
                                                    item
                                                )
                                            "
                                            (blur)="
                                                textboxBlur(
                                                    item.EmpSettingValue,
                                                    item
                                                )
                                            "
                                            [formControlName]="
                                                item.EmpSettingType
                                            "
                                            [name]="item.EmpSettingType"
                                        />
                                    </div>
                                    <div *ngIf="item.IsReadOnly">
                                        &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                    </div>
                                </ng-template>
                                <ng-template
                                    *ngSwitchCase="'password'"
                                    pTemplate="output"
                                >
                                    &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                </ng-template>
                            </p-cellEditor> -->
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </form>
</div>
